<div class="forms-wrapper">
  <div class="ion-padding">
    <div class="login-form">
      <div class="logo ion-text-center">
        <a href="https://communibee.ca" target="_blank" rel="noopener"><img src="assets/image/cb-logo.png"
            alt=""></a>
      </div>

      <app-login-form *ngIf="view === loginView.login" (registerClicked)="registerClicked($event)"
        (forgotClicked)="forgotPassword($event)" (loginComplete)="loginComplete()">
      </app-login-form>

      <app-register-form *ngIf="view === loginView.register" (loginClicked)="view = loginView.login"
        (registerComplete)="registerComplete($event)" [email]="emailForForgot"></app-register-form>

      <app-request-reset-form *ngIf="view === loginView.requestReset" (loginClicked)="view = loginView.login" 
        [email]="emailForForgot">
      </app-request-reset-form>

    </div>


    <div class="footer">
      <div class="ion-text-center" style="margin-top:20px;">
        <small class="uppercase">
          <ion-text color="dark">Version: {{version}} &copy;{{currentYear}} <strong><a href="https://launch57.com" rel="noopener"
                target="_blank">Launch57 Inc.</a></strong></ion-text>
        </small>
      </div>
    </div>
  </div>

  <p class="ion-text-center privacy-terms">
    <ion-text color="medium">
      By {{view === loginView.register ? 'registering' : 'logging in' }}, you are accepting our <span class="link"
        (click)="openTerms()">Terms
        and Conditions</span> and our <span class="link" (click)="openPrivacy()">Privacy Policy</span>
    </ion-text>
  </p>
</div>